// Flow - Chained Actions that pass data continuously between steps.

// TODO - convert everything to this.
Jelly.Actions.Flow  = 
{
	Current_Flow: null
};

Jelly.Actions.Flow.Register = function (Parameters) { 

	// TODO - only works for modals
	Jelly.Actions.Flow.Current_Flow = $("#" + Parameters["Namespace"]).parents(".Modal_Wrapper")[0];

	// TODO - hack, no multiple handlers yet
	var Existing_Dismiss = null;
	if (Jelly.Actions.Flow.Current_Flow) {
		Existing_Dismiss = Jelly.Actions.Flow.Current_Flow.Jelly_Reference.Handlers["Dismiss"]
	}

	// Add dismiss handler that unregisters Flow
	Jelly.Handlers.Register_Handler({
		"Element": Jelly.Actions.Flow.Current_Flow,
		"Event": "Dismiss",
		"Code": function (Parameters) {
			Jelly.Actions.Flow.Current_Flow = null;
			if (Existing_Dismiss)
				Existing_Dismiss();
		}
	});

};

Jelly.Actions.Flow.Next = function (Parameters) {


	// TODO - I overwrote the namespace functionality quickly.
	Parameters["Namespace"] = 
		$(Jelly.Actions.Flow.Current_Flow).
			find("[data-kind=\"Item\"][data-type=\"Flow_Action\"]")[0].
				id;

	// This is a W.I.P
	Parameters.Calling_Namespace = Parameters.Namespace;
	
	// Get first parent reference with a URL property (copied from Fill Parent)
	var Recursive_Parent_Reference = Jelly.References.Get_Reference_For_Element($('#' + Parameters["Namespace"]).get(0)).Parent_Reference;
	while (Recursive_Parent_Reference) {
		if (Recursive_Parent_Reference["URL"])
			break;
		Recursive_Parent_Reference = Recursive_Parent_Reference["Parent_Reference"];
	}		
	Flow_Wrapper_Reference = Recursive_Parent_Reference;
	
	// Show loading for flow_action
	$("#" + Parameters.Namespace + " .Flow_Buttons").addClass("Flow_Loading");

	// Get current input values.
	var Current_Values = Jelly.References.Get_Input_Values_For_Action({Namespace: Parameters["Namespace"]});

	// Don't propagate some values
	Object.keys(Current_Values).filter(function(Index){
		if ($(Jelly.Actions.Get_Input_From_Action_By_Alias({Namespace: Parameters.Namespace, Alias: Index})).hasClass("Do_Not_Flow")) {
			console.log("Deleting " + Index);
			delete Current_Values[Index];
		}
	});

	var Current_Values_String = "";
	$.each(Current_Values, function (Index, Value) { 
		if (Current_Values_String != "")
			Current_Values_String += ",";
		Current_Values_String += Index + "=" + encodeURIComponent(Value);
	});

	if (Parameters["Next_Step_ID"]) {
		// Move to next step

		// Register an onload handler for next step that re-adds inputs
		Jelly.Handlers.Register_Handler({
			"Element": Flow_Wrapper_Reference.Element,
			"Event": "On_Load",
			"Code": function(Parameters) {

				// Remove loading
				$("#" + Parameters.Namespace + " .Button_Container").removeClass("Flow_Loading");

				// TODO - can be generalized
				// Focus this window
				Jelly.Handlers.Call_Handler_For_Target({
						'Event': 'Focus', 
						'Target':Parameters['Target'],
						'Display_Target': Parameters['Display_Target'],
					}
				);

				// Re-Insert Input Values on load.
				$.each(Current_Values, function (Index, Value) { 
					Jelly.Actions.Add_Hidden_Value({
						Namespace: Jelly.References.Get_Reference_For_Element(Parameters["Target"]).Namespace,
						Input_Alias: Index,
						Value: Value
					});
				});
										
				// Detach this handler (unless it does it already)
				delete Flow_Wrapper_Reference.Handlers[Parameters["Event"]];
			}
		});		
	
		// Move to next step,
		
		Jelly.Handlers.Visit_Link({
			Calling_Element: $('#' + Parameters["Calling_Namespace"]).get(0),
			URL: "/flow_action/"  + Parameters["Next_Step_ID"]  + "?:" + Current_Values_String,
			Container: "Parent"
		});	
		
	}
	else { 
		
		// Move to confirmation
		Jelly.Handlers.Call_Handler_For_Target({
			'Event': 'Dismiss', 
			'Target': $("#" + Parameters.Calling_Namespace).get(0)
		});

		Jelly.Handlers.Visit_Link({
			Calling_Element: $('#' + Parameters["Calling_Namespace"]).get(0),
			URL: "/flow/"  + Parameters["Flow_ID"]  + "/" + "Confirmation" + "?:" + Current_Values_String,
			Container: "Window"
		});	

	}
};